import { APP_LOADING } from "../types/commonTypes";

export function loadingReducer(state = false, action: any) {
  switch (action.type) {
    case APP_LOADING:
      return action.payload;
    default:
      return state;
  }
}